const _SEARCH_PARAMS    = new URLSearchParams(window.location.search)
const _PRESELECT_VARIANT    = _SEARCH_PARAMS.get('bottle_select') || false

switch (_PRESELECT_VARIANT) {
    case '1':
        $("#oneBottle").prop("checked", true);
        break
    case '2':
        $("#twoBottles").prop("checked", true);
        break
    case '3':
        $("#threeBottles").prop("checked", true);
        break        
    default:
        console.log('default')
}

$(function() {

    const combined_object = {}

    // Loop through Shopify Product Variant array
    for(let variant in shopify_variants) {

        if(recharge_variants == null) {

            // Remove subscription option
            // $('.product-details__frequency-selection').fadeOut(0);

            // Translate key name into valid property name syntax
            let translation = [
                {'originalName': '1 Bottle', 'translatedName' : 'oneBottle'},
                {'originalName': '2 Bottles', 'translatedName': 'twoBottles'},
                {'originalName': '3 Bottles', 'translatedName': 'threeBottles'},
                {'originalName': '1 Pouch', 'translatedName' : 'oneBottle'},
                {'originalName': '2 Pouches', 'translatedName': 'twoBottles'},
                {'originalName': '3 Pouches', 'translatedName': 'threeBottles'}
            ];

            let variant_name

            for(let name in translation) {
                if(translation[name].originalName === shopify_variants[variant].title) {
                    variant_name = translation[name].translatedName;
                    break;
                }
            }

            // Check if a translation was found
            if(!variant_name) {
                console.error(`Variant Translation failed for ${shopify_variants[variant].title}!`)
                continue;
            }

            // Create a new object that combines meta sets
            combined_object[variant_name] = {
                'variationId' : {
                    'once'        : shopify_variants[variant].id,
                    'subscription': shopify_variants[variant].id
                },
                'price'    : {
                    'once'        : (shopify_variants[variant].price / 100).toFixed(2),
                    'subscription': ((shopify_variants[variant].price / 100) * 0.9).toFixed(2)
                },
                'comparePrice'    : {
                    'once'        : (shopify_variants[variant].compare_at_price / 100).toFixed(2),
                    'subscription': (shopify_variants[variant].compare_at_price / 100).toFixed(2)
                }
            };

            continue;
        }

        // Check if the Shopify Variant ID is found in reCharge's variant object
        if(recharge_variants.hasOwnProperty(shopify_variants[variant].id)) {

            // Translate key name into valid property name syntax
            let translation = [
                {'originalName': '1 Bottle', 'translatedName' : 'oneBottle'},
                {'originalName': '2 Bottles', 'translatedName': 'twoBottles'},
                {'originalName': '3 Bottles', 'translatedName': 'threeBottles'},
                {'originalName': '1 Pouch', 'translatedName' : 'oneBottle'},
                {'originalName': '2 Pouches', 'translatedName': 'twoBottles'},
                {'originalName': '3 Pouches', 'translatedName': 'threeBottles'}                
            ];

            let variant_name

            for(let name in translation) {
                if(translation[name].originalName === shopify_variants[variant].title) {
                    variant_name = translation[name].translatedName;
                    break;
                }
            }

            // Check if a translation was found
            if(!variant_name) {
                console.error(`Variant Translation failed for ${shopify_variants[variant].title}!`)
                continue;
            }

            // Create a new object that combines meta sets
            combined_object[variant_name] = {
                'variationId' : {
                    'once'        : shopify_variants[variant].id,
                    'subscription': shopify_variants[variant].id
                },
                'price'    : {
                    'once'        : (shopify_variants[variant].price / 100).toFixed(2),
                    'subscription': recharge_variants[shopify_variants[variant].id].discount_variant_price
                },
                'comparePrice'    : {
                    'once'        : (shopify_variants[variant].compare_at_price / 100).toFixed(2),
                    'subscription': (shopify_variants[variant].compare_at_price / 100).toFixed(2)
                }
            };

        }
    }

    /**
     * Detects selected product and looks up combined_object values and inserts into UI
     */
    function productSelection() {
        const frequency = $('[name=frequencySelection]:checked').val();
        const quantity  = $('[name=quantitySelection]:checked').val();

        // Set prices in UI
        $('.subscribe-label').children('.frequency-selection__price')
            .html(`$${combined_object[quantity].price.subscription}`);

        $('.one-time-label').children('.frequency-selection__price')
            .html(`$${combined_object[quantity].price.once}`);

        $('.product-details__current-price').html(`Now <span class='reg_price_container'>$<span class='reg_price'>${combined_object[quantity].price[frequency]}</span></span>`)
        $('.product-details__original-price').html(`$${combined_object[quantity].comparePrice[frequency]}`)

        // AfterPay
        document.querySelector('afterpay-placement').amount = combined_object[quantity].price[frequency];
        console.log('amount', combined_object[quantity].price[frequency])

        // Shadow root font resizing for AfterPay
        document.querySelector('afterpay-placement').setAttribute('style', 'font-size:12px !important;');
        // if(frequency === 'subscription') {
        //     document.querySelector('afterpay-placement').shadowRoot.querySelector('.afterpay-main-text').innerHTML = 'Not Available for Subscribe & Save&nbsp;'
        // }

        $('[name=selected_variation_id]').val(`${combined_object[quantity].variationId[frequency]}`);
    }

    productSelection();


    $('input[type=radio][name=frequencySelection], input[type=radio][name=quantitySelection]').on('change', ()=>productSelection());


});

  $(document).ready(function(){
    if (searchParams.has('offer')) {
        if(searchParams.get('offer') == promoConfig.offerParameter) {
            $('.product-details__frequency-selection').hide();
            adjustPricing(promoConfig.offerDiscount);

        }
        $('.bottles input[type=radio]').change(function() {
            adjustPricing(promoConfig.offerDiscount);
        });
    }    
  });

  function calculateDiscountedPrice(price, discountPercentage) {
        let discount = price * discountPercentage;
        let discountedPrice = price - (Math.floor(discount * 100) / 100);
        return discountedPrice.toFixed(2);
  }

  function adjustPricing(discountPercentage) {
    $('.reg_price_container').addClass('red_strike');
    let price = $('.reg_price').text();
    let discountedPrice = calculateDiscountedPrice(price, discountPercentage);        
      console.log('Regular Price: ' + price)
      console.log('Discounted Price: ' + discountedPrice)
    $('.reg_price_container').after('<span class=\'special_price\'>$' + discountedPrice + '</span>');
  }      